import _ from 'lodash';
import React from 'react';
import { WppListItem, WppMenuContext, WppInput, WppIconChevron } from 'buildingBlocks';
import { optionsUpdated } from 'containers/StrategyAnalytics/constants/actionsConstants';
import { SegmentGroup, DropdownItems } from 'containers/StrategyAnalytics/types';
import { options } from 'containers/StrategyAnalytics/constants/strategyAnalyticsConstants';
import SegmentOptions from './SegmentOptions';

type SegmentFilterProps = {
  segments: DropdownItems
  segmentGroups: Array<SegmentGroup>
  defaultValue: string
  onClick: Function
  id: string
};

const SegmentFilter = ({ id, segments, segmentGroups, defaultValue, onClick }: SegmentFilterProps) => {
  const selectedValue = options.bySegment[defaultValue].text;
  const bySegmentAllValue = options.bySegment.all.value;
  return (
    <WppMenuContext id={id} dropdownConfig={{ triggerElementWidth: true }} style={{ width: 'auto' }}>
      <WppInput
        slot="trigger-element"
        value={selectedValue}
        readOnly
        size="s"
        className="tree-menu"
      >
        <WppIconChevron direction="down" slot="icon-end" />
      </WppInput>
      <div>
        <WppListItem
          key={bySegmentAllValue}
          value={bySegmentAllValue}
          active={_.isEqual(options.bySegment[defaultValue].text, bySegmentAllValue)}
          onWppChangeListItem={() => onClick(optionsUpdated.bySegment, bySegmentAllValue)}
        >
          <p slot="label">{options.bySegment.all.text}</p>
        </WppListItem>
        <SegmentOptions
          array={segmentGroups}
          onClick={onClick}
          isSelected={selectedValue}
          type={options.bySegment.group.value}
          actionType={optionsUpdated.segmentGroup}
        />
        <SegmentOptions
          array={segments}
          onClick={onClick}
          isSelected={selectedValue}
          type={options.bySegment.id.value}
          actionType={optionsUpdated.segment}
        />
      </div>
    </WppMenuContext>
  );
};

export default SegmentFilter;
